import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { projectDriveFileBackend } from './project-drive-files.backend';
import { projectDriveFilesReducer } from './project-drive-files.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('projectDriveFiles', projectDriveFilesReducer),
    BackendModule.forFeature('projectDriveFiles', projectDriveFileBackend),
  ],
})
export class DatastoreProjectDriveFilesModule {}
